import { render, staticRenderFns } from "./team-chunk.vue?vue&type=template&id=acf22f0a&scoped=true"
import script from "./team-chunk.vue?vue&type=script&lang=js"
export * from "./team-chunk.vue?vue&type=script&lang=js"
import style0 from "./team-chunk.vue?vue&type=style&index=0&id=acf22f0a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acf22f0a",
  null
  
)

export default component.exports